import React from "react";
import { CheckPicker, Form } from "rsuite";
import styled from "styled-components";

import { FilterSectionFlexboxGrid, StyledItemAutoMargin, StyledItemFitWidth } from "components/base/FitContainers";
import CheckboxFullControl from "components/Form/CheckboxFullControl";
import { ButtonPrimary } from "components/base/BaseButton";
import CustomField from "components/Form/CustomField";


const UsersFilter = ({
    filters,
    isMobile,
    roleList = [],
    setFilters,
    setShowModalCreate,
}) => {
    return <FilterSectionFlexboxGrid isMobile={isMobile}>
        <StyledItemFitWidth isMobile={isMobile} controlable={!isMobile} group mr={20}>
            <StyledForm
                layout="inline"
                formValue={filters}
                onChange={setFilters}
            >
                <CustomField
                    name="str"
                    placeholder="Login, Name, Telegram, Email"
                    width={isMobile ? "100%" : "360px"}
                />
                <CustomField
                    accepter={CheckPicker}
                    width={isMobile ? "100%" : "220px"}
                    data={roleList.map(x => ({ value: x, label: x }))}
                    labelKey="label"
                    valueKey="value"
                    name="role_list"
                    placeholder="Select roles"
                />
                <CustomField
                    accepter={CheckboxFullControl}
                    name="show_only_active"
                >
                    Show only active users
                </CustomField>
            </StyledForm>
        </StyledItemFitWidth>
        <StyledItemAutoMargin isMobile={isMobile}>
            <ButtonPrimary
                onClick={() => setShowModalCreate(true)}
            >
                + Create User
            </ButtonPrimary>
        </StyledItemAutoMargin>
    </FilterSectionFlexboxGrid>
};

export default UsersFilter;

const StyledForm = styled(Form)`
    && .rs-form-group {
        margin-bottom: 0px;
    }
`;